import { createRouter, createWebHistory } from "vue-router";

import LandingPage from "../views/Landing.vue";
import MessageOfTheDay from "../components/MessageOfTheDay.vue";
import DashPages from "../views/DashPages.vue";
import DashboardPageOne from "../components/DashboardPageOne.vue";
import DashboardPageTwo from "../components/DashboardPageTwo.vue";
import DiseaseMngtContainer from "../components/DiseaseMngtContainer.vue";

import { createPinia } from "pinia";

import { usePatientStore } from "@/stores/patientStore";

// * STOREs
import { useStoreUser } from "@/stores/userStore";

import HomeOne from "../views/HomeOne.vue";
import UserProfileOptions from "@/modules/User/UserProfileOptions.vue";

import Scheduler from "../views/Scheduler.vue";
import VisitSummaryMedsGrid from "@/modules/Patient/VisitSummaryMedsGrid.vue";
import PatientDxCodeMapping from "@/modules/Patient/PatientDxCodeMapping.vue";

import PatientImmunizations from "@/modules/Patient/PatientImmunizations.vue";
import devMasterPatientList from "@/views/devMasterPatientList.vue";

import BLANK from "../views/BLANK.vue";

// import PhysiciansConsole from "@/src/PhysiciansConsole.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    // {
    //   path: "/landing",
    //   name: "LandingPage",
    //   component: () => import("../views/Landing.vue"),
    //   meta: { requiresAuth: false },
    // },
    {
      path: "/emr",
      name: "emr",
      meta: { requiresAuth: true },
      component: () => import("../PhysiciansConsole.vue"),
      redirect: "/emr/patients", // Optional: default redirect
      children: [
        {
          path: "/emr/Patient/:id",
          // because we want encounter to be default child route, we take out the name here and give it to default route below
          // name: 'Patient',
          meta: { requiresAuth: true },
          redirect: { name: "problemList" },
          component: () => import(/* webpackChunkName: 'view-HCC' */ "@/views/HCC/Chart.vue"),
          beforeEnter: async (to, from, next) => {
            // console.clear()
            // console.log(" ROUTER >>  beforeEnter   >>>  is setting  Patient ID  >>> ");
            const id = +to.params.id;
            const patientStore = usePatientStore();

            await patientStore.fetchAdminDropdownLists();

            if (patientStore.currentPatientId === id) {
            } else {
              // &     PATIENT STORE      getPatientById
              // console.log("patientStore         patientStore.getPatientById(id)                   s");
              await patientStore.getPatientById(id);
              // &     PATIENT STORE      getPatientDXCodes
              // console.log("patientStore           ADD PAT str  getPatientDXCodes");
              await patientStore.getPatientDXCodes(id);
            }
            next();
          },
          props: true,
          children: [
            {
              // default child route has parent name and redirects to encounter
              name: "problemList",
              path: "ProblemList",
              meta: { requiresAuth: true },
              component: () => import(/* webpackChunkName: 'view-ProblemList' */ "@/views/HCC/ProblemList.vue"),
              beforeEnter: async (to, from, next) => {
                // console.clear()
                // console.clear()
                // console.log(" ROUTER >>  beforeEnter   >>>  is setting  Patient ID  >>> ");
                // const id = +to.params.id;
                // const patientStore = usePatientStore();

                // if (patientStore.currentPatientId === id) {
                // } else {
                //   // // &     PATIENT STORE      getPatientById
                //   // console.log("patientStore         patientStore.getPatientById(id)                   s");
                //   // await patientStore.getPatientById(id);
                //   // &     PATIENT STORE      getPatientDXCodes
                //   console.log("patientStore           ADD PAT str  getPatientDXCodes");
                //   await patientStore.getPatientDXCodes(id);
                // }
                next();
              },
              redirect: { name: "assessment" },
              props: true,
              children: [
                {
                  path: "assessment",
                  name: "assessment",
                  meta: { requiresAuth: true },
                  component: () => import(/* webpackChunkName: 'view-ProblemList' */ "../modules/Patient/PatientAssessments.vue"),
                  props: (route) => ({ records: usePatientStore().assessmentRecords, worklistName: "assessment", worklistId: 0 }),
                  beforeEnter: (to, from, next) => {
                    next();
                  },
                },
                // {
                //   path: "encounter",
                //   name: "encounter",
                //   // * TEMP
                //   component: () => import(/* webpackChunkName: 'view-encounter' */ "@/modules/Patient/GenericCharts.vue"),

                //   props: (route) => ({ records: usePatientStore().encounterRecords, worklistName: "encounter", worklistId: 0 }),

                //   beforeEnter: (to, from, next) => {
                //     console.log(" +++++++++++++++++++          NEW patient store caLL TO api                                        PAT str call >> patientStore ");

                //     const pinia = createPinia();
                //     const patientStore = usePatientStore();
                //     console.log(patientStore.encounterRecords);
                //     console.log(patientStore.encounterRecords?.length);

                //     // console.log(' ROUTER >>  beforeEnter   >>>  is setting  Patient ID  >>> ')
                //     //     const pRecords = +to.params.records
                //     //     console.log('pRecords')
                //     //     console.log(pRecords)

                //     next();
                //   },
                // },
                // {
                //   path: "active",
                //   name: "active",
                //   component: () => import(/* webpackChunkName: 'view-active' */ "@/modules/Patient/GenericCharts.vue"),
                //   props: (route) => ({ records: usePatientStore().activeRecords, worklistName: "active", worklistId: 1 }),
                //   beforeEnter: (to, from, next) => {
                //     next();
                //   },
                // },
                {
                  path: "historic",
                  meta: { requiresAuth: true },
                  component: () => import(/* webpackChunkName: 'view-historic' */ "@/modules/Patient/GenericCharts.vue"),
                  name: "historic",
                  props: (route) => ({ records: usePatientStore().historicRecords, worklistName: "historic", worklistId: 2 }),
                  beforeEnter: (to, from, next) => {
                    next();
                  },
                },
                {
                  path: "all",
                  meta: { requiresAuth: true },
                  component: () => import(/* webpackChunkName: 'view-all' */ "@/modules/Patient/GenericCharts.vue"),
                  name: "all",
                  props: (route) => ({ records: usePatientStore().allRecords, worklistName: "all", worklistId: 3 }),
                  beforeEnter: async (to, from, next) => {
                    // console.clear()

                    // console.log(" ROUTER >>  beforeEnter   >>>  is setting  Patient ID  >>> ");
                    // const id = +to.params.id;

                    // const pinia = createPinia();
                    // const patientStore = usePatientStore();
                    // console.log(patientStore.encounterRecords);
                    // console.log(patientStore.encounterRecords?.length);

                    // console.log(" ROUTER >>  beforeEnter   >>>  is setting  Patient ID  >>> ");

                    // console.log(usePatientStore().allRecords);

                    // if (patientStore.allRecords.length === 0) {
                    //   // // &     PATIENT STORE      getPatientById
                    //   console.log("patientStore         patientStore.getPatientById(id)                   s");
                    //   await patientStore.getPatientById(id);
                    //   // &     PATIENT STORE      getPatientDXCodes
                    //   console.log("patientStore           ADD PAT str  getPatientDXCodes");
                    //   patientStore.getPatientDXCodes(id);
                    // }

                    next();
                  },
                },
                {
                  path: "newCode",
                  name: "newcode",
                  meta: { requiresAuth: true },
                  // component: () => import(/* webpackChunkName: 'view-DXCodeLookup' */ '@/views/DXCodeLookup/NIHCodeLookup.vue'),
                  component: () => import(/* webpackChunkName: 'view-newCode' */ "@/views/HCC/NewCode.vue"),

                  beforeEnter: (to, from, next) => {
                    next();
                  },
                },

                // {
                //   path: 'specialists',
                //   component: () => import(/* webpackChunkName: 'specialists' */ '@/modules/Patient/PatientSpecializations.vue'),
                //   name: 'specialists',
                //   beforeEnter: (to, from, next) => {
                //     next()
                //   },
                // },
              ],
            },
            {
              path: "inpatient",
              component: () => import(/* webpackChunkName: 'in-patient' */ "@/modules/Patient/PatientInPatientVisits.vue"),
              name: "inpatient",
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                next();
              },
            },
            {
              path: "encounters",
              component: () => import(/* webpackChunkName: 'in-patient' */ "@/modules/Patient/PatientEncounters.vue"),
              name: "encounters",
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                next();
              },
            },
            // ! TO REPLACE route of PROBLEMLIST >>>
            // {
            //   path: 'assestment',
            //   component: () => import(/* webpackChunkName: 'in-patient' */ '@/modules/Patient/Blank.vue'),
            //   name: 'assestment',
            //   beforeEnter: (to, from, next) => {
            //     next()
            //   },
            // },

            // {
            //   path: 'star-dx-codes',
            //   component: () => import(/* webpackChunkName: 'view-all' */ '@/modules/Patient/StarDXCodes.vue'),
            //   name: 'starDXCodes',
            //   beforeEnter: (to, from, next) => {
            //     next()
            //   },
            // },
            // {
            //   path: 'codingProblems',
            //   component: () => import(/* webpackChunkName: 'view-codingProblems' */ '@/views/HCC/Chart.vue'),
            //   name: 'codingProblems',
            //   beforeEnter: (to, from, next) => {
            //     next()
            //   },
            // },
            {
              path: "prescriptions",
              component: () => import(/* webpackChunkName: 'view-HCC' */ "@/modules/Patient/PatientMedications.vue"),
              name: "prescriptions",
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                next();
              },
            },
            {
              path: "labResults",
              component: () => import(/* webpackChunkName: 'view-HCC' */ "@/modules/Patient/PatientLabResults.vue"),
              name: "labResults",
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                next();
              },
            },
            {
              path: "vitals",
              component: () => import(/* webpackChunkName: 'view-HCC' */ "@/modules/Patient/PatientVitals.vue"),
              name: "vitals",
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                next();
              },
            },
            {
              path: "immunizations",
              component: () => import(/* webpackChunkName: 'view-HCC' */ "@/modules/Patient/PatientImmunizations.vue"),
              name: "immunizations",
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                next();
              },
            },
            {
              path: "procedures",
              component: () => import(/* webpackChunkName: 'view-HCC' */ "@/modules/Patient/PatientProcedures.vue"),
              name: "procedures",
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                next();
              },
            },
            {
              path: "allergies",
              component: () => import(/* webpackChunkName: 'view-HCC' */ "@/modules/Patient/PatientAllergies.vue"),
              name: "allergies",
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                next();
              },
            },
            {
              path: 'documents',
              component: () => import(/* webpackChunkName: 'view-HCC' */ '@/modules/Patient/PatientDocuments.vue'),
              name: 'documents',
              beforeEnter: (to, from, next) => {
                next()
              }
            },
            // {
            //   path: 'reminders',
            //   component: () => import(/* webpackChunkName: 'view-HCC' */ '@/modules/Patient/PatientReminders.vue'),
            //   name: 'reminders',
            //   beforeEnter: (to, from, next) => {
            //     next()
            //   },
            // },
            // {
            //   path: 'tasks',
            //   component: () => import(/* webpackChunkName: 'tasks' */ '@/modules/Patient/PatientTasks.vue'),
            //   name: 'tasks',
            //   beforeEnter: (to, from, next) => {
            //     next()
            //   },
            // },

            {
              path: "measures",
              component: () => import(/* webpackChunkName: 'stars' */ "@/modules/Patient/PatientMeasures.vue"),
              name: "measures",
              meta: { requiresAuth: true },
              beforeEnter: (to, from, next) => {
                next();
              },
            },
            // {
            //   path: 'stars',
            //   component: () => import(/* webpackChunkName: 'stars' */ '@/modules/Patient/PatientStars.vue'),
            //   name: 'stars',
            //   beforeEnter: (to, from, next) => {
            //     next()
            //   },
            // },
            {
              path: "comms",
              component: () => import(/* webpackChunkName: 'comms' */ "@/modules/Patient/PatientCommunications.vue"),
              name: "Communications",
              meta: { requiresAuth: true },
              // children: [
              //   {
              //     path: "comms",
              //     name: "communication",
              //     component: () => import(/* webpackChunkName: 'comms' */ "@/modules/Patient/PatientCommunicationsDummy.vue"),
              //     //props: (route) => ({ records: store.getters.encounterRecords, worklistName: 'encounter', worklistId: 0 }),
              //     beforeEnter: (to, from, next) => {
              //       next();
              //     },
              //   },
              //   {
              //     path: "tasks",
              //     name: "tasks",
              //     component: () => import(/* webpackChunkName: 'tasks' */ "@/modules/Patient/PatientTasks.vue"),
              //     //props: (route) => ({ records: store.getters.activeRecords, worklistName: 'active', worklistId: 1 }),
              //     beforeEnter: (to, from, next) => {
              //       next();
              //     },
              //   },
              // ],
              beforeEnter: (to, from, next) => {
                next();
              },
            },
            // {
            //   path: 'disease',
            //   component: () => import(/* webpackChunkName: 'stars' */ '@/modules/Patient/PatientDiseaseManagement.vue'),
            //   name: 'disease',
            //   beforeEnter: (to, from, next) => {
            //     next()
            //   },
            // },
          ],
        },
        {
          path: "patients", // RELATIVE path (not /emr/patients)
          name: "patients",
          meta: { requiresAuth: true },
          component: () => import("../views/TodaysPatients.vue"),
        },
        {
          path: "Dashboard", // RELATIVE path (not /emr/Dashboard)
          name: "Dashboard",
          component: DashPages,
          meta: { requiresAuth: true },
          redirect: "/emr/Dashboard/Primary", // Default dashboard view
          children: [
            {
              path: "Primary", // RELATIVE path (not /Dashboard/Primary)
              name: "Primary",
              meta: { requiresAuth: true },
              component: DashboardPageOne,
            },
            {
              path: "MyWork", // RELATIVE path (not /Dashboard/MyWork)
              name: "MyWork",
              meta: { requiresAuth: true },
              component: DashboardPageTwo,
            },
            {
              path: "disease-management", // RELATIVE path (not /Dashboard/DiseaseManagement)
              name: "disease-management",
              meta: { requiresAuth: true },
              component: DiseaseMngtContainer,
            },
          ],
        },
        {
          path: "NIHCodeLookup",
          name: "NIHCodeLookup",
          component: () => import(/* webpackChunkName: 'view-DXCodeLookup' */ "@/views/DXCodeLookup/NIHCodeLookup.vue"),
        },
      ],
    },
    {
      path: "/Admin",
      name: "Admin",
      // * ADMIN
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("../Admin.vue"),
    },
    {
      path: "/PatientPortal",
      name: "PatientPortal",
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("../PatientPortal.vue"),
    },
    {
      path: "/Billing",
      name: "Billing",
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("../Billing.vue"),
    },
    {
      path: "/NOC",
      name: "NOC",
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("../NOC.vue"),
    },
    {
      path: "/announcements",
      name: "announcements",
      meta: { requiresAuth: true },
      component: () => import("../components/MessageOfTheDay.vue"),
    },
    {
      path: "/practiceMgnt",
      name: "PracticeMgnt",
      component: () => import("../PracticeMgtDashboard.vue"),
    },
    {
      path: "/analytics",
      name: "analytics",
      component: () => import("../analytics.vue"),
    },
    {
      path: "/scheduler",
      name: "scheduler",
      component: () => import("../views/Scheduler.vue"),
    },

    {
      path: "/blank",
      name: "blank",
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("../views/BLANK.vue"),
    },
    {
      path: "/",
      redirect: "/emr", // "/patients" or "/Home" or whatever your main page is
    },
    {
      // path: "*",
      path: "/:catchAll(.*)",
      name: "NotFound",
      component: LandingPage, // WAS  Home
      meta: {
        requiresAuth: false,
      },
    },
  ],
});

// *  ROUTER GUARDS
router.beforeEach((to, from, next) => {
  const userStore = useStoreUser();
  //
  // console.log("to.meta.requiresAuth : ", to.meta.requiresAuth);
  // console.log("     userStore.isAuthenticated : ", userStore.isAuthenticated);
  // console.log();
  // console.log();
  // console.log("           ");

  // Check if the user is authenticated
  if (to.meta.requiresAuth && !userStore.isAuthenticated) {
    // next('/Grid') // Redirect to login page
    // console.log(" THIS REQUIRES  requiresAuth  && !userStore.isAuthenticated");
    // console.log("           Send User TO LOGIN somwhere ???????");
    next(); // Allow navigation
  } else {
    // console.log("    CONTINUE ON ROUTE                    no requirement ....                ");
    next(); // Allow navigation
  }
});

export default router;
